var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-char-icon",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.char)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }